export const menuItems = [
    {
        label: "menuitems.menu.text",
        isTitle: true
    },
    {
        label: 'menuitems.dashboard.text',
        icon: 'ri-dashboard-line',
        badge: {
            variant: "success",
            text: "menuitems.dashboard.badge"
        },
        link: '/'
    },
    {
        label: 'menuitems.admin.text',
        icon: 'ri-admin-fill',
        link: '/admin'
    },
    {
        label: 'menuitems.staff.text',
        icon: 'ri-user-4-fill',
        link: '/staff'
    },
    {
        label: 'menuitems.booking.text',
        icon: 'ri-order-play-fill',
        link: '/booking'
    },
    {
        label: 'menuitems.branch.text',
        icon: 'ri-store-2-line',
        link: '/branch'
    },
    {
        label: 'menuitems.treatment.text',
        icon: 'ri-product-hunt-fill',
        link: '/treatment'
    },
    {
        label: 'menuitems.category.text',
        icon: ' ri-list-unordered',
        link: '/category'
    },
    {
        label: 'menuitems.timeslot_category.text',
        icon: ' ri-list-ordered',
        link: '/timeslot-category'
    },
    {
        label: 'menuitems.report.text',
        icon: 'ri-file-chart-2-fill',
        link: '/report'
    },
    {
        label: 'menuitems.setting.text',
        icon: 'ri-settings-3-fill',
        subItems: [
            {
                label: 'menuitems.setting.list.branch_block_date',
                link: '/setting/branch-block-date'
            },
            {
                label: 'menuitems.setting.list.staff_block_date',
                link: '/setting/staff-block-date'
            },
            {
                label: 'menuitems.setting.list.role',
                link: '/setting/role'
            },
        ]
    },
]